import classnames from 'classnames';
import { FormattedMessage } from 'components/shared/Intl';
import { LightAlert } from 'components/shared/LightAlert';
import { FC } from 'react';

type OwnProps = {
  showReloadInformation: boolean;
};

export const ReloadInformation: FC<OwnProps> = ({ showReloadInformation }) => {
  return (
    <div className={classnames({ 'd-none': !showReloadInformation })}>
      <LightAlert
        key="product-modification-reload-information"
        severity="info"
        e2e="product-modification-reload-information"
      >
        <FormattedMessage id="productModification.sidePanel.information.reload" />
      </LightAlert>
    </div>
  );
};
ReloadInformation.displayName = 'ReloadInformation';
